import Node from './node';

export default class Branch extends Node {
  clone() {
    return new Branch(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
